import * as u from './utils';
import Cookies from 'js-cookie';

export default () => {
    if (!Cookies.get('flag-flashed')) {
        u.addClass(document.body, 'flag-flash');
    }

    if (Cookies.get('cookieyes-necessary') || Cookies.get('cookieyes-consent')) {
        Cookies.set('flag-flashed', 1, { expires: 30 });
    }
};
